<template>
  <div>
    <section class="playlist-search hero is-primary">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <div class="field">
                <p
                  class="control has-icons-left has-icons-right"
                  :class="{ 'is-loading': false }"
                >
                  <input
                    v-model="filter"
                    class="input"
                    type="text"
                    placeholder="Search"
                    @keydown.esc.prevent="clearFilter()"
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-search" />
                  </span>
                  <span class="icon is-small is-right clickable">
                    <a
                      v-if="filter"
                      class="delete"
                      href="#"
                      @click.prevent="clearFilter()"
                    />
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="playlist-list">
      <div
        v-for="playlist in playlists"
        :key="playlist.id"
        class="playlist is-fullwidth"
        @click="showPlaylist(playlist)"
      >
        <div class="container">
          <div class="content">
            <p class="list-element-title">
              <span v-text="playlist.name" />
            </p>
          </div>
        </div>
      </div>
    </div>
    <BaseRouterRoundButton :destination="addLink" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { onBottom } from "src/services/infinite-loading";
import { debounce } from "lodash";

export default {
  data() {
    return {
      addLink: "new-playlist"
    };
  },
  computed: {
    ...mapGetters({
      playlists: "playlists"
    }),
    filter: {
      get() {
        return this.$store.getters.playlistsFilter;
      },
      set(value) {
        this.changeFilter(value).then(this.refreshPlaylists.bind(this));
      }
    }
  },
  created() {
    this.$store
      .dispatch("changePlaylistsFilter")
      .then(this.setupQuery(this.filter));
  },
  mounted() {
    this.quickRefreshPlaylists();
    onBottom(() => {
      this.$store.dispatch("loadMorePlaylists");
    });
  },
  methods: {
    setupQuery(filter) {
      const query = {};
      if (filter) {
        query.filter = filter;
      }
      this.$router.replace({ query });
    },
    showPlaylist(playlist) {
      this.setCurrentPlayList(playlist);
      this.$router.push({
        name: "playlist",
        params: { playlistId: playlist.id }
      });
    },
    changeFilter(value) {
      this.setupQuery(value);
      return this.$store.dispatch("changePlaylistsFilter", value);
    },
    clearFilter() {
      return this.changeFilter("").then(this.quickRefreshPlaylists.bind(this));
    },
    quickRefreshPlaylists() {
      this.$store
        .dispatch("refreshPlaylists")
        .then(this.$store.dispatch("loadMorePlaylists"));
    },
    refreshPlaylists: debounce(function() {
      this.quickRefreshPlaylists();
    }, 500),
    ...mapActions(["setCurrentPlayList"])
  }
};
</script>

<style lang="scss">
.playlist-search .hero-body {
  padding: 1.5rem;
}
.playlist {
  @include list-element($fa-var-list-alt);
}
.add {
  @include action-button();
}
.control .icon.clickable {
  .delete {
    pointer-events: auto;
  }
}
</style>



// WEBPACK FOOTER //
// Playlists.vue?42d31ad6